import React from 'react'
import { DateField as RaDateField } from 'react-admin'

export const DateField = (props) => (
    <RaDateField {...props} locales='es-CL' options={{timeZone: 'UTC'}}/>
)
